<div class="other-charge-form" [formGroup]="form">
	<table mat-table [dataSource]="[{}]">
		<ng-container matColumnDef="autoRenew">
			<td mat-cell *matCellDef="let item" class="auto-renew">
				<mat-checkbox formControlName="autoRenew" matTooltip="Auto Renew"></mat-checkbox>
			</td>
		</ng-container>
		<ng-container matColumnDef="description">
			<td mat-cell *matCellDef="let item" class="description">
				<mat-form-field>
					<textarea matInput maxlength="100" placeholder="Description" formControlName="description"
						cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
						cdkAutosizeMaxRows="3">
					</textarea>
				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="chargeDate">
			<td mat-cell *matCellDef="let item" class="charge-date">
				<mat-form-field>
					<input matInput required formControlName="chargeDate" [matDatepicker]="chargeDate"
						autocomplete="off" placeholder="Date Of Charge" />
					<mat-datepicker-toggle matSuffix [for]="chargeDate"></mat-datepicker-toggle>
					<mat-datepicker #chargeDate></mat-datepicker>
					<mat-error *ngIf="form.controls['chargeDate'].invalid">{{
						getChargeDateErrorMessage()
						}}</mat-error>
				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="units">
			<td mat-cell *matCellDef="let item" class="units">
				<mat-form-field>
					<input matInput type="number" maxlength="25" placeholder="Units" formControlName="units" />
					<mat-error *ngIf="form.controls['units'].invalid">{{
						getUnitsErrorMessage()
						}}</mat-error>
				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="unitPrice">
			<td mat-cell *matCellDef="let item" class="unit-price">
				<mat-form-field>
					<rpshared-currency-input autocomplete="unit-price" formControlName="unitPrice"
						placeholder="Unit Price" [currencyCode]="currencyCode">
					</rpshared-currency-input>
					<mat-error *ngIf="form.controls['unitPrice'].invalid">{{
						getUnitPriceErrorMessage()
						}}</mat-error>
				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="amount">
			<td mat-cell *matCellDef="let item" class="amount">
				<mat-form-field>
					<rpshared-currency-input autocomplete="amount" readonly formControlName="amount"
						placeholder="amount" [currencyCode]="currencyCode">
					</rpshared-currency-input>
				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="serviceType">
			<td mat-cell *matCellDef="let item" class="service-type">
				<mat-form-field>
					<mat-select formControlName="serviceType" [compareWith]="compareServiceTypes" required
						placeholder="Service">
						<mat-option>--</mat-option>
						<mat-option *ngFor="let service of serviceTypes" [value]="service">
							{{ service.description }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</td>
		</ng-container>
		<ng-container matColumnDef="action">
			<td mat-cell *matCellDef="let item" class="actions">
				<button mat-icon-button type="submit" [disabled]="this.form.invalid" (click)="saveForm()"
					class="saveBtn" matTooltip="Save Charge">
					<mat-icon>save</mat-icon>
				</button>
				<button mat-icon-button (click)="reset()" matTooltip="Reset">
					<mat-icon>settings_backup_restore</mat-icon>
				</button>
				<button mat-icon-button (click)="cancelForm()" matTooltip="Cancel">
					<mat-icon>cancel</mat-icon>
				</button>
			</td>
		</ng-container>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>